import { transformFirebaseDate } from "../../../../utils/date";

export function transformCatchRegistrationData(data) {
  const submittedAt = transformFirebaseDate(data?.submittedAt);
  const dateOfBirth = transformFirebaseDate(data?.dateOfBirth);
  //console.log(submittedAt);
  //console.log(dateOfBirth);
  return { ...data, submittedAt: submittedAt, dateOfBirth: dateOfBirth };
}
